"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.Action = exports.defaultLanguages = void 0;
exports.reducer = reducer;
const constructors_union_1 = require("@genesys/client-core/lib/constructors-union");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
exports.defaultLanguages = ["en-GB", "en-US"];
exports.Action = (0, constructors_union_1.ctorsUnion)({
    SetTextIssues: (issues) => ({ issues }),
    SystemTypeValidationSetSettings: (settings) => ({ settings }),
    SystemTypeValidationToggleFilter: () => ({}),
    SystemTypeValidationHideFilter: () => ({}),
    SystemTypeValidationSetValidationProgress: (inProgress, message, current, max) => ({ inProgress, message, current, max }),
    SystemTypeValidationSetResult: (messages) => ({
        messages
    }),
    SystemTypeValidationToggleSelectedLanguages: (language) => ({
        language
    }),
    SystemTypeValidationSetShowLanguages: (showLanguagesList) => ({
        showLanguagesList
    }),
    SystemTypeValidationCheckAllLanguages: (languages) => ({ languages }),
    SystemTypeValidationUnCheckAllLanguages: () => ({}),
    SystemTypeValidationCheckDefaultLanguages: () => ({})
});
exports.initialState = {
    loading: false,
    filterCollapsed: false,
    validationProgress: {
        inProgress: false,
        message: "",
        current: 0,
        max: 0
    },
    settings: {
        systemTypeId: undefined,
        validateRangeFilters: false,
        validateSysAndNewFilters: false,
        validateTemplates: false,
        validateEnergy: false,
        validateValueSourceUsage: false,
        validateCalculationMappings: false,
        validateCircularReferences: false,
        validateCostTables: false,
        validateProperties: false,
        validatePropertyTexts: false,
        languagesToValidate: [],
        skipRetired: true,
        errorsOnly: false
    },
    showLangugagesList: false,
    messages: [],
    issues: []
};
// biome-ignore lint: -
function reducer(state = exports.initialState, action) {
    switch (action.type) {
        case "SetTextIssues": {
            return Object.assign(Object.assign({}, state), { issues: action.issues });
        }
        case "SystemTypeValidationSetSettings": {
            return Object.assign(Object.assign({}, state), { settings: action.settings });
        }
        case "SystemTypeValidationSetValidationProgress": {
            return Object.assign(Object.assign({}, state), { issues: action.inProgress ? [] : state.issues, validationProgress: Object.assign(Object.assign({}, state.validationProgress), { inProgress: action.inProgress, message: action.message, current: action.current, max: action.max }) });
        }
        case "SystemTypeValidationSetResult": {
            return Object.assign(Object.assign({}, state), { loading: false, messages: action.messages });
        }
        case "SystemTypeValidationToggleFilter": {
            return Object.assign(Object.assign({}, state), { filterCollapsed: !state.filterCollapsed });
        }
        case "SystemTypeValidationHideFilter": {
            return Object.assign(Object.assign({}, state), { filterCollapsed: true });
        }
        case "SystemTypeValidationSetShowLanguages": {
            return Object.assign(Object.assign({}, state), { showLangugagesList: action.showLanguagesList });
        }
        case "SystemTypeValidationToggleSelectedLanguages": {
            const newState = state.settings.languagesToValidate.some(l => l === action.language)
                ? state.settings.languagesToValidate.filter(l => l !== action.language)
                : state.settings.languagesToValidate.concat(action.language);
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { languagesToValidate: newState }) });
        }
        case "SystemTypeValidationUnCheckAllLanguages": {
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { languagesToValidate: [] }) });
        }
        case "SystemTypeValidationCheckAllLanguages": {
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { languagesToValidate: action.languages }) });
        }
        case "SystemTypeValidationCheckDefaultLanguages": {
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { languagesToValidate: exports.defaultLanguages }) });
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
        }
    }
    return state;
}
//# sourceMappingURL=system-type-validation-state.js.map